import { render } from "./OrderListNav.vue?vue&type=template&id=6848bb3e&ts=true"
import script from "./OrderListNav.vue?vue&type=script&lang=ts"
export * from "./OrderListNav.vue?vue&type=script&lang=ts"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__